var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseQuotedMessage',{staticClass:"q-mb-sm cursor-pointer",attrs:{"message":_vm.normalizedMessage,"contact-name":_vm.contactName},on:{"click":function($event){return _vm.$emit('scroll-to-parent')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }